import {
    FETCH_ADD_CART,
    FETCH_REMOVE_CART,
    FETCH_ERROR,
    FETCH_CART,
} from "../types/types";

const initialState = {
    Error: "",
    cartItems: [],
    Total: 0,
};

export const cartReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ADD_CART:
            const item = action.payload;
            const existItem = state.cartItems.find(
                (x) => x.product === item.product
            );
            if (existItem) {
                return {
                    ...state,
                    cartItems: state.cartItems.map((x) =>
                        x.product === existItem.product ? item : x
                    ),
                };
            } else {
                return { ...state, cartItems: [...state.cartItems, item] };
            }
        case FETCH_REMOVE_CART:
            return {
                ...state,
                cartItems: state.cartItems.filter(
                    (x) => x.product !== action.payload
                ),
            };

        case FETCH_ERROR:
            return {
                ...state,
                Error: action.payload,
            };

        case FETCH_CART:
            const items = JSON.parse(localStorage.getItem("cartItems"));
            if (!items) {
                return {
                    ...state,cartItems:[],Total:0
                };
            } else {
                const total = items.reduce((a, c) => a + c.price * c.qty, 0);
                return {
                    ...state,
                    cartItems: items,
                    Total: total,
                };
            }

        default:
            return state;
    }
};
